import React from "react";
import AdminContinentsRoutes from "./AdminContinentsRoutes";

import { useTracking } from "react-tracking";
import { useDispatch, useSelector } from "react-redux";
import { startRegisterTrackingHistory } from "../../app/actions/trackingHistoryActions";

const AdminContinentsScreen = () => {
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.auth);

  const { Track } = useTracking(
    {
      module: "Administration Catalog Continents",
      page: "Admin Catalog Continent Screen",
      user_id: user.user_id,
      user_name: user.user_name,
      
    },
    {
      dispatch: (data) => {

        dispatch(startRegisterTrackingHistory(data));
        
      },
    }
  );

  return (
    <div>
      <Track>
        <AdminContinentsRoutes />
      </Track>
    </div>
  );
};

export default AdminContinentsScreen;
